/** Remove legacy prerender hero shell if present (homepage no longer injects #static-hero). */
export function removeStaticHero() {
  document.getElementById('static-hero')?.remove();
}

/** Remove route-specific LCP shell injected at build time for hub/listing pages. */
export function removeRouteLcpShell() {
  document.getElementById('route-lcp-shell')?.remove();
}

/** Remove build-time crawl HTML once React paints (same content as SPA route). */
export function removeSeoCrawl() {
  document.getElementById('seo-crawl')?.remove();
  document.getElementById('seo-breadcrumbs')?.remove();
}

export function removePrerenderShells() {
  removeStaticHero();
  removeRouteLcpShell();
  removeSeoCrawl();
}

export function isHomePath(pathname: string): boolean {
  const path = pathname || '/';
  return path === '/' || path === '';
}

export function hasRouteLcpShell(): boolean {
  return document.getElementById('route-lcp-shell') != null;
}
